import Constants from '../../../constants';

export const BaseUrl = `${Constants.baseApiHost}/api/v2/dataexport/`;
export const ExportHistoryUrls = {
  Search: `${BaseUrl}search`,
  Get: `${BaseUrl}`,
  Download: `${BaseUrl}download/`
};
